import React, { useContext, useMemo } from 'react'
import { Col, Row } from 'react-angle-dashboard-components'
import { useHistory } from 'react-router-dom'
import { Question, QuestionContainer } from '../../components/Question'
import { useUpdateValue } from '../../hooks/use-capture-question'
import useStep from '../../hooks/use-step'
import { Paths } from '../../routes/paths'
import { GbsStore } from '../../store'
import { useStepData } from '../../store/selectors'

const stepKey = 'planningPurchasing'

export const PlanningPurchasing = () => {
  const { dispatch } = useContext(GbsStore)
  const history = useHistory()
  const stepData = useStepData(stepKey)
  const defaultValue = stepData?.value || ''
  const { updateValue, isLoading } = useUpdateValue(stepKey)

  const options = [
    {
      label: "I'm ready today",
      value: "I'm ready today",
      text: ''
    },
    {
      label: 'Next Week',
      value: 'Next Week',
      text: ''
    },
    {
      label: 'In 1 to 2 months',
      value: 'In 1 to 2 months',
      text: ''
    },
    {
      label: 'After 3 months',
      value: 'After 3 months',
      text: ''
    }
  ]

  const onContinue = async (value: any) => {
    if (isLoading) return

    const wasSuccesfull = await updateValue(value, {
      planned_purchase_timeframe: value
    })

    if (!wasSuccesfull) return

    history.push(Paths.newHealth)
  }

  const stepConfig = useMemo(() => {
    return {
      topBar: {
        completedPercentage: 20,
        backCallback: () => history.push(Paths.currentlyMedical)
      },
      bottomBar: {
        hidden: true
      }
    }
  }, [history])

  useStep(stepKey, stepConfig, dispatch)

  return (
    <QuestionContainer>
      <Row>
        <Col xs={12}>
          <Question
            options={options}
            type="choice"
            defaultValue={defaultValue}
            text="When are you planning on purchasing health insurance?"
            onChange={onContinue}
          ></Question>
        </Col>
      </Row>
    </QuestionContainer>
  )
}

export default PlanningPurchasing
